import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const categories = [
  { key: 'shoes', icon: 'ri-footprint-line', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { key: 'hoodies', icon: 'ri-shirt-line', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { key: 'tshirts', icon: 'ri-t-shirt-air-line', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { key: 'jackets', icon: 'ri-windy-line', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { key: 'pants', icon: 'ri-pantone-line', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { key: 'headwear', icon: 'ri-base-station-line', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { key: 'sets', icon: 'ri-stack-line', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { key: 'underwear', icon: 'ri-shirt-line', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { key: 'jersey', icon: 'ri-vip-diamond-line', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { key: 'accessories', icon: 'ri-glasses-line', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { key: 'bags', icon: 'ri-handbag-line', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { key: 'belts', icon: 'ri-link', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { key: 'perfumes', icon: 'ri-contrast-drop-line', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { key: 'other', icon: 'ri-more-line', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

const subpages = [
  { label: 'Kakobuy Guide', path: '/kakobuy-spreadsheet-guide', icon: 'ri-book-open-line' },
  { label: 'CSSBuy Guide', path: '/cssbuy-spreadsheet-guide', icon: 'ri-file-list-3-line' },
  { label: 'Superbuy Guide', path: '/superbuy-spreadsheet-guide', icon: 'ri-truck-line' },
  { label: 'Oopbuy Guide', path: '/oopbuy-spreadsheet-guide', icon: 'ri-seedling-line' },
  { label: 'Bezpieczeństwo', path: '/shopping-safety-guide', icon: 'ri-shield-check-line' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileGuidesOpen, setMobileGuidesOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Lock body scroll when the mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  return (
    <>
      <nav className="fixed top-0 left-0 w-full z-50 bg-background-50/80 backdrop-blur-md border-b border-background-200/60">
        <div className="w-full px-6 md:px-10">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-xl font-heading font-semibold text-foreground-950 whitespace-nowrap cursor-pointer">
              Kakobuy Finds
            </Link>

            <div className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
                {t('nav.home')}
              </Link>

              <div ref={dropdownRef} className="relative">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {t('nav.categories')}
                  <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>

                {dropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-60 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 max-h-80 overflow-y-auto">
                    {categories.map((cat) => (
                      <a
                        key={cat.key}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <span className="w-7 h-7 rounded-lg bg-background-200/60 flex items-center justify-center flex-shrink-0">
                          <i className={`${cat.icon} text-xs text-foreground-600`}></i>
                        </span>
                        {t(`categories.${cat.key}`)}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative group">
                <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
                  {t('nav.guide')}
                  <i className="ri-arrow-down-s-line"></i>
                </button>
                <div className="absolute top-full left-0 mt-2 w-52 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  {subpages.map((sp) => (
                    <Link
                      key={sp.path}
                      to={sp.path}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <span className="w-7 h-7 rounded-lg bg-background-200/60 flex items-center justify-center flex-shrink-0">
                        <i className={`${sp.icon} text-xs text-foreground-600`}></i>
                      </span>
                      {sp.label}
                    </Link>
                  ))}
                </div>
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm font-semibold bg-primary-500 text-background-50 px-5 py-2 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                kakobuy sheet
              </a>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-950 relative z-[70]"
              aria-label="Menu"
            >
              <i className={`text-xl transition-transform duration-200 ${mobileMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu rendered OUTSIDE <nav> to avoid the backdrop-filter containing-block bug */}
      {mobileMenuOpen && (
        <div
          className="md:hidden fixed inset-0 z-[60] bg-white"
          style={{ height: '100dvh' }}
        >
          <div className="flex flex-col h-full">
            {/* Menu header row (aligns with navbar height, keeps close button reachable) */}
            <div className="flex items-center justify-between h-16 px-5 border-b border-gray-100 flex-shrink-0">
              <span className="text-xl font-heading font-semibold text-gray-900">Kakobuy Finds</span>
              <button
                onClick={() => setMobileMenuOpen(false)}
                className="w-10 h-10 flex items-center justify-center text-gray-900 cursor-pointer"
                aria-label="Close menu"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {/* Scrollable menu body */}
            <div className="flex-1 overflow-y-auto px-5 pt-4 pb-10 space-y-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3.5 py-2 text-base font-medium text-gray-900 cursor-pointer"
              >
                <span className="w-9 h-9 rounded-xl bg-orange-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-home-4-line text-orange-600 text-sm"></i>
                </span>
                {t('nav.home')}
              </Link>

              <div className="border-t border-gray-100 pt-3">
                <button
                  onClick={() => setMobileCatOpen(!mobileCatOpen)}
                  className="w-full flex items-center justify-between py-2 text-base font-semibold text-gray-800 cursor-pointer"
                >
                  <span className="flex items-center gap-3.5">
                    <span className="w-9 h-9 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-grid-line text-amber-600 text-sm"></i>
                    </span>
                    {t('nav.categories')} (14)
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform duration-200 text-gray-400 ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
                </button>

                {mobileCatOpen && (
                  <div className="mt-1 ml-[3.25rem] flex flex-col">
                    {categories.map((cat) => (
                      <a
                        key={cat.key}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        onClick={() => setMobileMenuOpen(false)}
                        className="flex items-center gap-3 py-2.5 text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                      >
                        <span className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                          <i className={`${cat.icon} text-[11px] text-gray-500`}></i>
                        </span>
                        {t(`categories.${cat.key}`)}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <div className="border-t border-gray-100 pt-3">
                <button
                  onClick={() => setMobileGuidesOpen(!mobileGuidesOpen)}
                  className="w-full flex items-center justify-between py-2 text-base font-semibold text-gray-800 cursor-pointer"
                >
                  <span className="flex items-center gap-3.5">
                    <span className="w-9 h-9 rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-book-read-line text-teal-600 text-sm"></i>
                    </span>
                    {t('nav.guide')}
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform duration-200 text-gray-400 ${mobileGuidesOpen ? 'rotate-180' : ''}`}></i>
                </button>

                {mobileGuidesOpen && (
                  <div className="mt-1 ml-[3.25rem] flex flex-col">
                    {subpages.map((sp) => (
                      <Link
                        key={sp.path}
                        to={sp.path}
                        onClick={() => setMobileMenuOpen(false)}
                        className="flex items-center gap-3 py-2.5 text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                      >
                        <span className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                          <i className={`${sp.icon} text-[11px] text-gray-500`}></i>
                        </span>
                        {sp.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <div className="border-t border-gray-100 pt-5">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center justify-center gap-2 w-full bg-orange-500 text-white px-6 py-3.5 rounded-full text-sm font-semibold hover:bg-orange-600 transition-colors cursor-pointer"
                >
                  <i className="ri-shopping-bag-line"></i>
                  kakobuy sheet
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}